import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BarChart3Icon, CandlestickChartIcon, CrownIcon, LayoutDashboardIcon, ShieldCheckIcon, XIcon } from 'lucide-react';
const navItems = [{
  label: 'Terminal',
  href: '#terminal',
  Icon: LayoutDashboardIcon
}, {
  label: 'Mercados',
  href: '#mercados',
  Icon: BarChart3Icon
}, {
  label: 'Estrategia',
  href: '#estrategia',
  Icon: CandlestickChartIcon
}, {
  label: 'Fondeo',
  href: '#fondeo',
  Icon: ShieldCheckIcon
}, {
  label: 'Acceso VIP',
  href: '#acceso',
  Icon: CrownIcon
}];
function BrandBlock() {
  return <div className="border-b border-line px-6 py-6" data-id="element-72" data-mp="nz8hlaptlyvx">
      <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-cyan-vip" data-id="element-73" data-mp="nzqk2p32t9ca">
        Trading Terminal
      </p>
      <p className="mt-2 font-display text-[34px] leading-none tracking-tight text-white" data-id="element-74" data-mp="szw53meubxle">
        INDICADORES
      </p>
      <p className="mt-1 font-mono text-[13px] tracking-[0.32em] text-gold-vip" data-id="element-75" data-mp="12vzftgnrd4jy">
        VIP
      </p>
      <p className="mt-4 text-[11px] italic leading-relaxed text-white/30" data-id="element-76" data-mp="1l0i3h1l03hs0">
        “La precisión no es una opinión.”
      </p>
    </div>;
}
function NavList({
  onNavigate
}: {
  onNavigate?: () => void;
}) {
  return <nav aria-label="Principal" className="flex flex-col gap-0.5 px-3 py-5" data-id="element-77" data-mp="1b1u3riwvvpd4">
      {navItems.map(({
      label,
      href,
      Icon
    }) => <a key={href} href={href} onClick={onNavigate} className="group flex items-center gap-3 rounded-md px-3 py-2.5 text-[14px] text-white/60 transition-colors duration-150 ease-out hover:bg-white/[0.04] hover:text-white focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-cyan-vip" data-id="element-78" data-mp="172lasg9o3vim">
          <Icon className="h-4 w-4 shrink-0 text-white/35 transition-colors duration-150 ease-out group-hover:text-cyan-vip" aria-hidden="true" data-id="element-79" data-mp="1q0ebrd0qdvdd" />
          {label}
        </a>)}
    </nav>;
}
function SidebarFooter() {
  return <div className="mt-auto border-t border-line px-6 py-5" data-id="element-80" data-mp="2hp7ov1vu6siq">
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/25" data-id="element-81" data-mp="futekc3movi1">
        v1.0 · Protocolo de Apertura
      </p>
      <p className="mt-1 font-mono text-[10px] text-white/20" data-id="element-82" data-mp="kuo8ypmm437u">
        © indicadoresvip.com
      </p>
    </div>;
}
interface SidebarProps {
  mobileOpen: boolean;
  onClose: () => void;
}
export function Sidebar({
  mobileOpen,
  onClose
}: SidebarProps) {
  return <>
      <aside className="sticky top-[76px] hidden h-[calc(100vh-76px)] w-[248px] shrink-0 flex-col border-r border-line bg-ink lg:flex" data-id="element-83" data-mp="3t6ttzzrxui7j">
        <BrandBlock data-id="element-84" data-mp="3ja8nfa09sz1l" />
        <NavList data-id="element-85" data-mp="3jaqp4m5pc5gw" />
        <SidebarFooter data-id="element-86" data-mp="3jba9samql7ym" />
      </aside>

      <AnimatePresence data-id="element-87" data-mp="3jcboqq6vielm">
        {mobileOpen ? <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed inset-0 z-[80] bg-black/70 lg:hidden" onClick={onClose} data-id="element-88" data-mp="3o8ilbsddqdqw">
            <motion.aside initial={{
          x: -24,
          opacity: 0
        }} animate={{
          x: 0,
          opacity: 1
        }} exit={{
          x: -24,
          opacity: 0
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} onClick={event => event.stopPropagation()} className="flex h-full w-[280px] flex-col border-r border-line bg-ink" aria-label="Menú" data-id="element-89" data-mp="3711155hn2f3w">
              <div className="relative" data-id="element-90" data-mp="3ponzappqu9i4">
                <BrandBlock data-id="element-91" data-mp="3lp5myibzn6qw" />
                <button type="button" onClick={onClose} aria-label="Cerrar menú" className="absolute right-3 top-3 inline-flex h-9 w-9 items-center justify-center rounded-md border border-white/10 text-white/60 transition-colors duration-150 ease-out hover:text-cyan-vip focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-cyan-vip" data-id="element-92" data-mp="3lnucy0ry92rc">
                  <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-93" data-mp="20dndpfv7qzv4" />
                </button>
              </div>
              <NavList onNavigate={onClose} data-id="element-94" data-mp="21v2oz06lvzrx" />
              <SidebarFooter data-id="element-95" data-mp="26qrq37y9xoqc" />
            </motion.aside>
          </motion.div> : null}
      </AnimatePresence>
    </>;
}